<template>
  <div ref="picker" class="picker airport-picker">
    <div :class="{ loading: isLoading, noicon: !isIcon }">
      <span v-if="isIcon" class="icon">&#x2708;</span>
      <input v-model="query" type="text" aria-label="airport" :placeholder="placeholder" @blur="blur" @input="search" @click="init" @focus="init" @keyup.up="moveUp" @keyup.down="moveDown" @keyup.enter="update(selected)" />
      <ul v-show="isSearching">
        <li v-for="(place, index) in data" :key="index" :class="{ on: isSelected(place), selected: isSelected(place) }" @mouseout="focus(-1)" @mouseover="focus(index)" @click="update(place)">
          {{ place.title }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import useApi from "../../utils/apiCalls";

const props = defineProps({
  airport: {
    type: [Object, String],
    default: null,
  },
  placeholder: String,
  isIcon: {
    type: Boolean,
    default: true,
  },
  showTitle: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["error", "update:airport"]);
const { apiGetRequest } = useApi(emit);

const picker = ref(null);
const data = ref([]);
const focusIndex = ref(-1);
const isLoading = ref(false);
const isSearching = ref(false);
const query = ref(props.airport?.iata ?? "");
const querySaved = ref("");
const selected = ref(props.airport);

const blur = () => {
  if (focusIndex.value > -1) {
    update(data.value[focusIndex.value]);
  } else if (selected.value) {
    update(selected.value);
  }
};

const focus = index => {
  focusIndex.value = index;
};

const init = () => {
  isSearching.value = true;
  query.value = querySaved.value;
};

const moveDown = () => {
  if (!selected.value || !data.value.length) return;
  const last = data.value.length - 1;
  for (let i = 0; i <= last; i++) {
    if (data.value[i].id == selected.value.id) {
      selected.value = i < last ? data.value[i + 1] : data.value[0];
      break;
    }
  }
};

const moveUp = () => {
  if (!selected.value || !data.value.length) return;
  const last = data.value.length - 1;
  for (let i = 0; i <= last; i++) {
    if (data.value[i].id == selected.value.id) {
      selected.value = i > 0 ? data.value[i - 1] : data.value[last];
      break;
    }
  }
};

const scroll = () => {
  const el = document.querySelector(".picker");
  const rect = el.getBoundingClientRect();
  if (rect.top + 6 * 16 > (window.innerHeight || document.documentElement.clientHeight)) {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

const search = () => {
  if (query.value === "") return;
  isLoading.value = true;

  apiGetRequest({
    path: `/airports?query=${query.value}`,
    onSuccess: rsp => {
      data.value = rsp;
      if (data.value.length > 0) {
        selected.value = data.value[0];
      }
      scroll();
      isLoading.value = false;
    },
  });
};

const update = place => {
  if (!place) return;
  querySaved.value = query.value;
  isSearching.value = false;
  query.value = props.showTitle ? place.title : place.iata;
  selected.value = place;
  emit("update:airport", place);
};

const isSelected = place => {
  return selected.value && selected.value.id === place.id;
};

onMounted(() => {
  if (query.value && !data.value.length) search();
});
</script>
